import axios from "axios";
import { FigmaCleanupReportDto, FigmaCleanupReportDetailDto, TriggerFigmaCleanupResult } from "./models/figmaCleanupModels";

export const getFigmaCleanupReports = async (): Promise<FigmaCleanupReportDto[]> => {
    const { data: reports } = await axios.get<FigmaCleanupReportDto[]>(
        `${window.configuration.apiUrl}api/admin/figma-cleanup/reports`
    );
    return reports;
};

export const getFigmaCleanupReportDetail = async (id: number): Promise<FigmaCleanupReportDetailDto> => {
    const { data: report } = await axios.get<FigmaCleanupReportDetailDto>(
        `${window.configuration.apiUrl}api/admin/figma-cleanup/reports/${id}`
    );
    return report;
};

export const triggerFigmaCleanup = async (file: File): Promise<TriggerFigmaCleanupResult> => {
    const formData = new FormData();
    formData.append("file", file);

    const { data: result } = await axios.post<TriggerFigmaCleanupResult>(
        `${window.configuration.apiUrl}api/admin/figma-cleanup/trigger`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
    return result;
};
